import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';

import { AllServicesService } from '../app/all-services.service';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicStorageModule } from '@ionic/storage';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { ActionSheet, ActionSheetOptions } from '@ionic-native/action-sheet/ngx';
import { Toast } from '@ionic-native/toast/ngx';
import { NativeGeocoder, NativeGeocoderResult, NativeGeocoderOptions } from '@ionic-native/native-geocoder/ngx';
import { MediaCapture, MediaFile, CaptureError, CaptureImageOptions } from '@ionic-native/media-capture/ngx';
import { File } from '@ionic-native/file/ngx';
import { Media, MediaObject } from '@ionic-native/media/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { StreamingMedia, StreamingVideoOptions } from '@ionic-native/streaming-media/ngx';

import { Stripe } from '@ionic-native/stripe/ngx';

import { ViewAppointmentPageModule } from './view-appointment/view-appointment.module';
import { ViewTextPageModule } from './view-text/view-text.module';
import { RatingPageModule } from './rating/rating.module';
import { OfficedetailsPageModule } from './officedetails/officedetails.module';
import { ViewPolicyPageModule } from './view-policy/view-policy.module';

import { Device } from '@ionic-native/device/ngx';

// import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { SignaturePadModule } from 'angular2-signaturepad';

import { NativeAudio } from '@ionic-native/native-audio/ngx';
// import { SpeechRecognition } from '@ionic-native/speech-recognition/ngx';

import { TokboxService } from './services/tokbox.service';

import { CallingPageModule } from './calling/calling.module';
import { CallingdocPageModule } from './callingdoc/callingdoc.module';
// import { FCM } from '@ionic-native/fcm/ngx';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { Network } from '@ionic-native/network/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';

import { StarRatingModule } from 'ionic4-star-rating';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [ 
    BrowserModule,
    IonicModule.forRoot({animated: false}),
    AppRoutingModule,
    HttpClientModule,
    HttpModule,
    IonicStorageModule.forRoot(),
    ReactiveFormsModule,
    ViewAppointmentPageModule,
    ViewTextPageModule,
    RatingPageModule,
    OfficedetailsPageModule,
    ViewPolicyPageModule,
    SignaturePadModule,
    CallingPageModule,
    CallingdocPageModule,
    StarRatingModule 
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AllServicesService,
    Camera,
    FileTransfer,
    ActionSheet,
    Toast,
    NativeGeocoder,
    MediaCapture,
    Media,
    InAppBrowser,
    File,
    Stripe,
    StreamingMedia,
    Device,
    // IOSFilePicker,
    NativeAudio,
    TokboxService,
    Network,
    FileOpener,
    // FCM,
    // SpeechRecognition,
    OneSignal,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}




